<!-- Модальная оболочка формы выбора транспорта перед созданием акта. -->
<template>
  <BaseModal :visible="visible" title="Сдать/Принять ТС" size="lg" adaptive-fullscreen @close="$emit('close')">
    <VehicleInspectionSelectionForm
      v-if="visible"
      :form-id="formId"
      :initial-vehicle="initialVehicle"
      @submit="$emit('start', $event)"
      @submitting-change="isSubmitting = $event"
    />
    <template #footer>
      <base-primary-button type="submit" :form="formId" :disabled="isSubmitting">Продолжить</base-primary-button>
      <base-button :disabled="isSubmitting" @click="$emit('close')">Отмена</base-button>
    </template>
  </BaseModal>
</template>

<script>
import VehicleInspectionSelectionForm from "@/components/Vehicle/Inspection/Selection/Form.vue";

export default {
  name: "VehicleInspectionSelectionModal",
  components: { VehicleInspectionSelectionForm },
  props: {
    visible: { type: Boolean, required: true },
    initialVehicle: { type: Object, default: null },
  },
  emits: ["close", "start"],
  data() {
    return {
      formId: "vehicle-inspection-selection-form",
      isSubmitting: false,
    };
  },
  watch: {
    visible(value) {
      if (!value) this.isSubmitting = false;
    },
  },
};
</script>
